/** @module config/transitionWords */

/**
 * Returns a list of transition words consisting of single words
 *
 * @type {string[]} The list of single transition words.
 */
export const singleWords = [ "εξαιτίας", "επειδή", "γιατί", "διότι", "καθώς", "ώστε", "λοιπόν", "αλλά", "μα", "όμως ", "παρά", "μόνο", "μόλο",
	"ωστόσο", "εντούτοις", "έπειτα", "μολαταύτα", "μάλιστα", "εξάλλου", "αντίθετα", "απεναντίας", "διαφορετικά", "ειδάλλως ", "ειδεμή", "αλλιώς ",
	"αλλιώτικα", "πάλι", "ενώ", "μολονότι", "αντίστροφα", "αρχικά", "προγουμένως", "πρώτα", "ύστερα", "πριν", "εντωμεταξύ", "τέλος", "όταν",
	"καθ΄ψς", "όποτε", "μόλις", "αργότερα", "αν", "δηλαδή", "ειδικότερα", "ήτοι", "συγκεκριμένα", "ειδικά", "καταρχήν", "κατόπιν", "πρωταρχικα",
	"συγκεφαλαιωτικά", "συγκεφαλαιώνοντας", "συγκεντρωτικά", "συνοπτικά", "επιλογικά", "ανακεφαλαιώνοντας", "τελικά", "γενικά", "ευρύτερα",
	"επιπλέον", "επιπρόσθετα", "επίσης", "ακόμη", "πρόσθετα", "όπως", "ομοίως", "σαν", "επομένως", "συνεπώς", "πράγματι", "βέβαια", "όντως",
	"αφού", "αφότου", "καταρχάς", "ακολούθως", "εφόσον", "κυρίως", "φυσικά", "ασφαλώς", "οπωσδήποτε", "αναντίρρητα", "προφανώς" ];

export const multipleWords = [ "παρόλο που", "ένας ακόμα λόγος", "αυτό οφείλεται", "αυτό εξηγείται", "αυτό δικαιλογείται", "η αιτία είναι",
	"ο λόγος είναι", "γι'αυτό τον λόγο", "παρόλα ταύτα", "ως επακόλουθο", "ως αποτέλεσμα", "κατά συνέπεια", "έτσι που", "και όμως", "και γι'αυτό",
	"σε αντίθεση", "από την άλλη πλευρά", "αν και", "και αν", "στον αντίποδα", "ακόμη κι αν", "παρ'όλα αυτά", "στη συνέχεια", "είναι γεγονός ότι",
	"αξίζει να σημειωθεί", "με άλλα λόγια", "αυτό σημαίνει ότι", "για παράδειγμα", "παραδείγματος χάριν", "λόγου χάριν", "σε περίπτωση που",
	"εκτός κι αν", "εξαιτίας αυτού", "με τον ίδιο τρόπο", "με παρόμοιο τρόπο", "με την προϋπόθεση να", "υπό τον όρο να", "εν κατακλείδι ",
	"χάρη σε αυτό", "από την στιγμή που", "έχει μεγάλη σημασία να", "είναι απαραίτητο να", "είναι αναγκαίο να", "είναι αξιοσημείωτο", "στο μεταξύ",
	"στην αρχή", "με δεδομένο" ];

export const allWords = singleWords.concat( multipleWords );

export default allWords;
